<div class="row">
    <div class="col-xs-12">
        <div class="card card--box card--box--dashboard">
            <div class="card-block card--box--dashboard__block">
            </div>
            <div class="card-block card--box--dashboard__block">
                <div class="row d-flex">
                    <div class="col-xs-7 d-flex flex-wrap">
                        <div class="row">
                            <div class="col-xs-12">
                                <h2 class="welcome">{{ 'Welcome!' | translate }}</h2>
                                <h2>{{ user['clinic'].name | translate }}</h2>
                            </div>
                        </div>
                        <div class="row quickstart align-self-end">
                            <h4 class="title col-xs-12">{{'Quick Start' | translate}}</h4>
                            <div class="col-xs-2 quickstart__item">
                                <a class="btn quickstart__item__btn" (click)="handleAddUser()">
                                    <i class="fas fa-plus"></i>
                                    <span class="quickstart__item__name">{{ 'Add User' | translate }}</span>
                                </a>
                            </div>
                            <div class="col-xs-2 quickstart__item">
                                <a class="btn quickstart__item__btn" (click)="handleEditClinic()">
                                    <i class="fas fa-hospital"></i>
                                    <span class="quickstart__item__name">{{ 'Edit Clinic' | translate }}</span>
                                </a>
                            </div>
                            <div class="col-xs-2 quickstart__item">
                                <a class="btn quickstart__item__btn" (click)="exportUser($event)">
                                    <i class="fas fa-download"></i>
                                    <span class="quickstart__item__name">{{ 'Admin Export data' | translate }}</span>
                                </a>
                            </div>
                            <div class="col-xs-2 quickstart__item">
                                <a class="btn quickstart__item__btn " [routerLink]="['/templates']">
                                    <i class="fas fa-file-alt"></i>
                                    <span class="quickstart__item__name">{{ 'Email Template' | translate }}</span>
                                </a>
                            </div>
                            <div class="col-xs-2 quickstart__item">
                                <a class="btn quickstart__item__btn " [routerLink]="['/activity-dashboard']">
                                    <i class="fas fa-chart-bar"></i>
                                    <span class="quickstart__item__name">{{ 'Activity Dashboard' | translate }}</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-5 card--box--dashboard__block">
                        <h4 class="title">{{'Notifications' | translate}}</h4>
                        <notification-list></notification-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row mr-t--md">
    <div class="col-xs-12">
        <users-component #usersComponent [isHome]="true" url="/home"></users-component>
    </div>
</div>

